const isMainnet = process.env.IS_MAINNET === "true";

export const TENET_STAKING_ADDRESS = isMainnet ? '0x7DBbbbbECb00e66E241B0A2885fA44BcD2C9C33C' : '0x3d888982871437dD236Dd726AA9AD481CB6EdF4e';
export const TENET_STAKING_ADDRESS_ETH = isMainnet ? '0x7DBbbbbECb00e66E241B0A2885fA44BcD2C9C33C' : '0xce827cFc516951Ea363e0B297C57Df8a8ECB6f5d';
